import React from 'react';
import { Translator } from 'Translator';
import { translateCity, translateCountry } from 'utils/TranslationHelper';
import classnames from 'classnames';
import { isCordova } from 'utils/platform';
import ChevronIcon from 'components/icons/ChevronIcon';
import SearchIcon from 'components/icons/SearchIcon';

const CSS = require('./LocationSearchTrigger.less');

function text(selectedCity, selectedCountry) {
  if (!selectedCity && !selectedCountry) {
    return Translator.translate('UserEnvironment.LocationSearchTrigger.startExploring', {}, true, 'Start exploring');
  }

  return `${selectedCity ? translateCity(selectedCity, true) : ''}${selectedCity ? ', ' : ''}${translateCountry(selectedCountry, true)}`;
}

function LocationSearchTrigger({ selectedCity, selectedCountry , onClick, onClose, alwaysShowBackButton = false }) {
  return (
    <div className={CSS.LocationSearchTrigger}>
      {(alwaysShowBackButton || (selectedCity && selectedCountry && isCordova())) ? (
        <button className={CSS.BackButton} onClick={onClose}>
          <ChevronIcon width={7} height={12} direction="left" className={classnames(CSS.Icon, CSS.BackIcon)} />
        </button>
      ) : (
        <SearchIcon width={21} height={21} className={classnames(CSS.Icon, CSS.SearchIcon)} />
      )}
      <button
        className={CSS.Button}
        onClick={onClick}
      >
        <span className={CSS.Text}>{text(selectedCity, selectedCountry)}</span>
      </button>
    </div>
  );
}

export default LocationSearchTrigger;
